/**
 * Custom Product Page JavaScript
 * Handles image gallery, variant selection, and interactions
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const productSection = document.querySelector('.custom-product-section');
    if (!productSection) return;

    const sectionId = productSection.dataset.sectionId;
    initImageGallery(sectionId);
    initVariantSelection(sectionId);
    initQuantitySelector(sectionId);
    initSealSubscriptions(sectionId);
    initProxyButtons(sectionId);
  }

  /**
   * Image Gallery - Thumbnail click to change main image
   */
  function initImageGallery(sectionId) {
  const mainImage = document.getElementById(`main-product-image-${sectionId}`);
  const thumbGallery = document.getElementById(`thumb-gallery-${sectionId}`);

  if (!mainImage || !thumbGallery) return;

  const thumbItems = thumbGallery.querySelectorAll('.thumb-item img');

  // ✅ Preload all large images
  thumbItems.forEach(img => {
    const fullUrl = img.getAttribute('data-full');
    if (fullUrl) {
      const preload = new Image();
      preload.src = fullUrl;
    }
  });

  // ✅ Handle thumbnail clicks
  thumbItems.forEach(img => {
    img.addEventListener('click', function() {
      const fullUrl = this.getAttribute('data-full');
      if (!fullUrl) return;

      // Fade transition
      mainImage.style.transition = 'opacity 0.25s ease';
      mainImage.style.opacity = '0.5';

      // Swap image
      setTimeout(() => {
        mainImage.src = fullUrl;
        mainImage.srcset = `${fullUrl} 1200w`;
        mainImage.style.opacity = '1';
      }, 150);
    });
  });
}



  /**
   * Variant Selection - Update price and variant ID
   */
  function initVariantSelection(sectionId) {
    const variantSelects = document.querySelectorAll(`#product-form-${sectionId} .variant-select`);
    const variantIdInput = document.getElementById(`product-variant-id-${sectionId}`);
    const addToCartBtn = document.getElementById(`add-to-cart-${sectionId}`);
    
    if (variantSelects.length === 0 || !variantIdInput) return;

    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        updateVariantPrice(sectionId);
      });
    });

    // Initial price update
    updateVariantPrice(sectionId);
  }

  /**
   * Update variant price and availability
   */
  function updateVariantPrice(sectionId) {
    const variantSelects = document.querySelectorAll(`#product-form-${sectionId} .variant-select`);
    const variantIdInput = document.getElementById(`product-variant-id-${sectionId}`);
    const priceWrapper = document.querySelector(`#product-${sectionId} .product-price-wrapper`);
    const addToCartBtn = document.getElementById(`add-to-cart-${sectionId}`);
    
    if (!variantIdInput || !priceWrapper) return;

    // Get selected options
    const selectedOptions = {};
    variantSelects.forEach(select => {
      const optionIndex = parseInt(select.dataset.optionIndex);
      selectedOptions[optionIndex] = select.value;
    });

    // Find matching variant
    // Note: This requires product data. In a real implementation, you'd fetch this from Shopify
    // For now, we'll use the variant ID from the form
    const currentVariantId = variantIdInput.value;
    
    // Update button state (placeholder - actual implementation would check variant availability)
    if (addToCartBtn) {
      // This would be updated based on actual variant availability
      // addToCartBtn.disabled = !variant.available;
    }
  }

  /**
   * Proxy buttons under gallery submit the main product form
   */
  function initProxyButtons(sectionId) {
    const addBtn = document.querySelector(`#product-${sectionId} [data-proxy-add]`);
    const buyBtn = document.querySelector(`#product-${sectionId} [data-proxy-buy]`);
    const form = document.getElementById(`product-form-${sectionId}`);

    if (addBtn && form) {
      addBtn.addEventListener('click', function() {
        form.submit();
      });
    }

    if (buyBtn && form) {
      buyBtn.addEventListener('click', function() {
        form.submit();
        // Navigate to cart after submission
        setTimeout(() => {
          window.location.href = '/cart';
        }, 200);
      });
    }
  }

  /**
   * Quantity Selector - Increment/Decrement buttons
   */
  function initQuantitySelector(sectionId) {
    const quantityInput = document.querySelector(`#quantity-${sectionId}`);
    if (!quantityInput) return;

    const minusBtn = quantityInput.parentElement.querySelector('.minus');
    const plusBtn = quantityInput.parentElement.querySelector('.plus');

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // Validate input
    quantityInput.addEventListener('change', function() {
      const value = parseInt(this.value);
      if (isNaN(value) || value < 1) {
        this.value = 1;
      }
    });

    quantityInput.addEventListener('blur', function() {
      const value = parseInt(this.value);
      if (isNaN(value) || value < 1) {
        this.value = 1;
      }
    });
  }

  /**
   * Seal Subscriptions Integration
   */
  function initSealSubscriptions(sectionId) {
    const subscriptionWidget = document.getElementById(`subscription-widget-${sectionId}`);
    if (!subscriptionWidget) return;

    const sealWidget = subscriptionWidget.querySelector('.seal-subscription-widget');
    if (!sealWidget) return;

    const productHandle = sealWidget.dataset.productHandle;
    const productId = sealWidget.dataset.productId;

    // Check if Seal Subscriptions script is loaded
    if (typeof Seal !== 'undefined' && Seal.init) {
      // Initialize Seal Subscriptions widget
      Seal.init({
        productHandle: productHandle,
        productId: productId,
        container: sealWidget
      });
    } else {
      // Load Seal Subscriptions script if not already loaded
      const script = document.createElement('script');
      script.src = 'https://cdn.sealsubscriptions.com/seal.js';
      script.async = true;
      script.onload = function() {
        if (typeof Seal !== 'undefined' && Seal.init) {
          Seal.init({
            productHandle: productHandle,
            productId: productId,
            container: sealWidget
          });
        }
      };
      document.head.appendChild(script);
    }

    // Alternative: Manual button handler
    const subscriptionBtn = document.getElementById('seal-subscription-btn');
    if (subscriptionBtn) {
      subscriptionBtn.addEventListener('click', function() {
        // Open Seal Subscriptions modal or redirect
        if (typeof Seal !== 'undefined' && Seal.openModal) {
          Seal.openModal({
            productHandle: productHandle,
            productId: productId
          });
        } else {
          // Fallback: redirect to subscription page or show alert
          alert('Subscription feature coming soon!');
        }
      });
    }
  }

  /**
   * Add to Cart - Enhanced with loading state
   */
  const addToCartForms = document.querySelectorAll('.product-form');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const submitBtn = this.querySelector('button[type="submit"][name="add"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
        
        // Re-enable after 3 seconds if no redirect (error handling)
        setTimeout(() => {
          if (submitBtn.disabled) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Add to Cart';
          }
        }, 3000);
      }
    });
  });

  /**
   * Buy Now - Direct to cart
   */
  const buyNowButtons = document.querySelectorAll('.btn-buy-now');
  buyNowButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      // Add to cart first, then redirect
      const form = this.closest('.product-form');
      if (form) {
        // In a real implementation, you'd add to cart via AJAX first
        // For now, we'll just redirect to cart
        window.location.href = '/cart';
      }
    });
  });

  /**
   * Smooth scroll for tabs
   */
  const tabSummaries = document.querySelectorAll('.tab-summary');
  tabSummaries.forEach(summary => {
    summary.addEventListener('click', function() {
      // Small delay to allow details to open
      setTimeout(() => {
        const details = this.closest('details');
        if (details && details.open) {
          details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 100);
    });
  });

})();





/****** Zooom **** */
/****** Zoom Popup with Next/Prev *****/
document.addEventListener('click', function (e) {
  const zoomLink = e.target.closest('[data-zoom]');
  if (!zoomLink) return;

  e.preventDefault();
  e.stopPropagation();

  // Avoid duplicate overlays
  if (document.querySelector('.zoom-overlay')) return;

  const sectionId = zoomLink.dataset.sectionId;
  const thumbGallery = document.getElementById('thumb-gallery-' + sectionId);
  const thumbImgs = thumbGallery ? Array.from(thumbGallery.querySelectorAll('.thumb-img')) : [];

  // Build full image URLs
  const imageUrls = thumbImgs.length
    ? thumbImgs.map((img) => img.getAttribute('data-full') || img.src.replace('width=150', 'width=1200'))
    : [zoomLink.href];

  // Determine current index
  let index = imageUrls.indexOf(zoomLink.href);
  if (index === -1) index = 0;

  // Create overlay
  const zoomOverlay = document.createElement('div');
  zoomOverlay.classList.add('zoom-overlay');
  zoomOverlay.innerHTML = `
    <div class="zoom-backdrop"></div>
    <div class="zoom-content">
      <button class="zoom-prev" aria-label="Previous image">‹</button>
      <img src="${imageUrls[index]}" alt="Zoomed image">
      <button class="zoom-next" aria-label="Next image">›</button>
      <button class="zoom-close" aria-label="Close">×</button>
    </div>
  `;
  document.body.appendChild(zoomOverlay);

  const zoomImg = zoomOverlay.querySelector('.zoom-content img');

  // Helper to show image
  function showImage(i) {
    index = (i + imageUrls.length) % imageUrls.length;
    zoomImg.style.opacity = '0.5';
    setTimeout(() => {
      zoomImg.src = imageUrls[index];
      zoomImg.style.opacity = '1';
    }, 100);
  }

  // Navigation
  zoomOverlay.querySelector('.zoom-prev').onclick = (ev) => {
    ev.stopPropagation();
    showImage(index - 1);
  };
  zoomOverlay.querySelector('.zoom-next').onclick = (ev) => {
    ev.stopPropagation();
    showImage(index + 1);
  };

  // Close handlers
  zoomOverlay.querySelector('.zoom-close').onclick = () => zoomOverlay.remove();
  zoomOverlay.querySelector('.zoom-backdrop').onclick = () => zoomOverlay.remove();

  // Keyboard navigation
  document.addEventListener('keydown', function escHandler(ev) {
    if (!document.querySelector('.zoom-overlay')) {
      document.removeEventListener('keydown', escHandler);
      return;
    }
    if (ev.key === 'Escape') {
      zoomOverlay.remove();
      document.removeEventListener('keydown', escHandler);
    } else if (ev.key === 'ArrowLeft') {
      showImage(index - 1);
    } else if (ev.key === 'ArrowRight') {
      showImage(index + 1);
    }
  });
});

/*********** */